// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* WARNING: This section must be updated if _variables.ts is changed */
/* PERCENTAGE COLOURS */
.text-medium {
  font-size: 14px;
}

.coloured-dot {
  height: 36px;
  width: 36px;
}

.colour-panel {
  border: 5px;
  width: 140px;
}

.project-name-col {
  flex: 0 0 21%;
  max-width: 21%;
}

.variations-chevron-col {
  flex: 0 0 4%;
  max-width: 4%;
}

.variations-list {
  background-color: #efefef;
}

.variations-list a {
  text-decoration: none;
  color: #000000;
}

.generic-table-header .coloured-dot,
.status-coloured-dot {
  height: 10px;
  width: 10px;
  margin-top: 2px;
  min-width: 10px;
}

.image-container {
  display: inline-block;
  height: 45px;
}
.image-container .image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.coating-system-images-container {
  width: 84px;
}

.results-text {
  font-weight: 600;
}

.sortable-fallback {
  display: none;
}

::ng-deep .dropdown-style .ng-select-container .ng-value-container .ng-value {
  padding-left: 10px;
}

.clients-col {
  flex: 0 0 11%;
  max-width: 11%;
}

.comments-col {
  flex: 0 0 4%;
  max-width: 4%;
}`, "",{"version":3,"sources":["webpack://./src/white-labelling/default/_variables.scss","webpack://./src/app/core/components/generic-table/generic-table.component.scss"],"names":[],"mappings":"AAgDA,sEAAA;AAYA,uBAAA;AC1DA;EACC,eAAA;AACD;;AAEA;EACC,YAAA;EACA,WAAA;AACD;;AAEA;EACC,WAAA;EACA,YAAA;AACD;;AAEA;EAEC,aAAA;EACA,cAAA;AACD;;AAEA;EAEC,YAAA;EACA,aAAA;AACD;;AAEA;EACC,yBDCkB;ACAnB;;AAEA;EACC,qBAAA;EACA,cAAA;AACD;;AAEA;;EAEC,YAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;AACD;;AAEA;EACC,qBAAA;EACA,YAAA;AACD;AAAC;EACC,WAAA;EACA,YAAA;EACA,mBAAA;AAEF;;AAEA;EACC,WAAA;AACD;;AAEA;EACC,gBAAA;AACD;;AAEA;EACC,aAAA;AACD;;AAEA;EACC,kBAAA;AACD;;AAEA;EAEC,aAAA;EACA,cAAA;AACD;;AAEA;EAEC,YAAA;EACA,aAAA;AACD","sourcesContent":["// Core theme colors\n$primary: #078BCB;\n$primary2: #067ab2;\n$primary3: #05699a;\n$selectedBackground: #ebf5ff;\n\n// Colour variables\n$black: #000000;\n$border-colour: #dee2e6;\n$card-border: #dfdfdf;\n$cardBorderGrey: #d9dee8;\n$disabled: #caced5;\n$disabledButtonColor: #7bb3d0;\n$disabled-background: #ececec;\n$form-error: #f84646;\n$highlight: #f5f5f5;\n$hoverHighlight: rgba(35, 31, 32, 0.31);\n$inactive: rgba(255, 0, 0, 0.1);\n$inactiveHighlight: rgba(255, 0, 0, 0.2);\n$kaliber-dark: #414448;\n$link: #2185d0;\n$placeholder: #aab2c0;\n$selectedButton: #002865;\n$subtitle: #a0a2a4;\n$white: #ffffff;\n$cardBorderGrey: #d9dee8;\n\n// Bootstrap Colours\n$secondary: #222222;\n$dark: #7a7a7a;\n$background-light: #efefef;\n$print-page-size: auto;\n\n$danger: #d9534f;\n$muted: #85959f;\n$text-muted: #85959f;\n$success: #61f2b6;\n$warning: #f0ad4e;\n$info: #5bc0de;\n$light: #f8f9fa;\n$light-gray: #d3d3d3;\n$background-dark: #414448;\n$disabled-background: rgba(221, 221, 221, 0.3) !default;\n\n// Common Styles\n$border: 1px solid $border-colour;\n$appComsHeight: 60px;\n\n/* WARNING: This section must be updated if _variables.ts is changed */\n$target: #fcb800;\n$declined: #d11f4b;\n$active: #f77f21;\n$quoteReady: #d299c4;\n$quoteApproved: #7c4795;\n$submitted: #662066;\n$won: #3e9937;\n$lost: #00245e;\n$live: #00b0f0;\n$completed: #a9d18e;\n\n/* PERCENTAGE COLOURS */\n$percentage-green: #15b422;\n$percentage-light-green: #a3d000;\n$percentage-yellow: #fcb000;\n$percentage-red: #ff0000;\n\n// DO NOT USE IF YOU SEE THESE BEING USED. PLEASE REMOVE\n$exportTableHeight: 530px;\n$footerHeight: 60px;\n$height650px: 650px;\n$headerNavHeight: 60px;\n$headerHeight: 42px;\n$inputPercentWidth: 91px;\n$inputDiscountWidth: 126px;\n$exportTableHeight: 530px;\n$incExcTableHeight: 300px;\n$sidebarMenuWidth: 120px;\n$sideNavWidth: 67px;\n$height650px: 650px;\n$headerNavHeight: 60px;\n\n// Image References\n$loginLogo: './assets';\n","@import 'variables';\n\n.text-medium {\n\tfont-size: 14px;\n}\n\n.coloured-dot {\n\theight: 36px;\n\twidth: 36px;\n}\n\n.colour-panel {\n\tborder: 5px;\n\twidth: 140px;\n}\n\n.project-name-col {\n\t-ms-flex: 0 0 21%;\n\tflex: 0 0 21%;\n\tmax-width: 21%;\n}\n\n.variations-chevron-col {\n\t-ms-flex: 0 0 4%;\n\tflex: 0 0 4%;\n\tmax-width: 4%;\n}\n\n.variations-list {\n\tbackground-color: $background-light;\n}\n\n.variations-list a {\n\ttext-decoration: none;\n\tcolor: #000000;\n}\n\n.generic-table-header .coloured-dot,\n.status-coloured-dot {\n\theight: 10px;\n\twidth: 10px;\n\tmargin-top: 2px;\n\tmin-width: 10px;\n}\n\n.image-container {\n\tdisplay: inline-block;\n\theight: 45px;\n\t.image {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tobject-fit: contain;\n\t}\n}\n\n.coating-system-images-container {\n\twidth: 84px;\n}\n\n.results-text {\n\tfont-weight: 600;\n}\n\n.sortable-fallback {\n\tdisplay: none;\n}\n\n::ng-deep .dropdown-style .ng-select-container .ng-value-container .ng-value {\n\tpadding-left: 10px;\n}\n\n.clients-col {\n\t-ms-flex: 0 0 11%;\n\tflex: 0 0 11%;\n\tmax-width: 11%;\n}\n\n.comments-col {\n\t-ms-flex: 0 0 4%;\n\tflex: 0 0 4%;\n\tmax-width: 4%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
